import { Injectable } from '@angular/core';

import type { Observable } from 'rxjs';
import { map } from 'rxjs';

import { TellentHttpApiService } from '@core/tellent-http-legacy';
import type { AddOrgPayload, NewOrgResponse, Org, OrgDeletionStatus } from '@core/tellent-types';

export type TellentOrganizationResponse = {
  org: Org;
};

@Injectable({ providedIn: 'root' })
export class TellentOrganizationHttpClient {
  constructor(protected httpApi: TellentHttpApiService) {}

  public fetch(): Observable<Org> {
    return this.httpApi
      .get('', null, null)
      .pipe(map((response: TellentOrganizationResponse) => response.org));
  }

  public update(body: Partial<Omit<Org, 'guid'>>): Observable<Org> {
    const formData = new FormData();

    Object.entries(body).forEach(([key, value]: [string, any]) => {
      if (value === undefined) return;
      const isFile = value instanceof File;

      formData.append(`${key}`, isFile ? <File>value : `${value}`);
    });
    return this.httpApi
      .patch('', null, formData)
      .pipe(map((response: TellentOrganizationResponse) => response.org));
  }

  public delete(code: string): Observable<Org> {
    return this.httpApi
      .post('/request-deletion', null, { code })
      .pipe(map((response: TellentOrganizationResponse) => response.org));
  }

  public addOrg(addOrg: AddOrgPayload): Observable<NewOrgResponse> {
    return this.httpApi
      .post('/orgs', null, addOrg)
      .pipe(map((response: { org: NewOrgResponse }) => response.org));
  }

  public deletionStatus(): Observable<OrgDeletionStatus> {
    return this.httpApi
      .get('/deletion-request', null)
      .pipe(map((response: { data: OrgDeletionStatus }) => response.data));
  }
}
